import api from "../../../api/index";

export function groups() {
  return api.get("groups");
}

export function users() {
  return api.get("users");
}

export function userGroup(id) {
  return api.get(`group/${id}`);
}

export function deleteGroup(id) {
  return api.delete(`group/${id}`);
}

export function removeUser(id, payload) {
  return api.delete(`group/${id}/removeUser`, { data: payload });
}

export function addUser(id, payload) {
  return api.post(`group/${id}/addUser`, payload);
}

export function createGroup(payload){
    return api.post("group", payload)
}
